enum Language {
    EN = "en",
    FR = "fr",
    NL = "nl"
}

export default Language;
